import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.5,2.85714844 L17.5,4.64285156 C17.5,6.21652344 13.5807422,7.5 8.75,7.5 C3.91925781,7.5 0,6.21652344 0,4.64285156 L0,2.85714844 C0,1.28347656 3.91925781,0 8.75,0 C13.5807422,0 17.5,1.28347656 17.5,2.85714844 Z M17.5,6.875 L17.5,10.8928516 C17.5,12.4665234 13.5807422,13.75 8.75,13.75 C3.91925781,13.75 0,12.4665234 0,10.8928516 L0,6.875 C1.87988281,8.16964844 5.320625,8.77234375 8.75,8.77234375 C12.179375,8.77234375 15.6200781,8.16964844 17.5,6.875 Z M17.5,13.125 L17.5,17.1428516 C17.5,18.7165234 13.5807422,20 8.75,20 C3.91925781,20 0,18.7165234 0,17.1428516 L0,13.125 C1.87988281,14.4196484 5.320625,15.0223438 8.75,15.0223438 C12.179375,15.0223438 15.6200781,14.4196484 17.5,13.125 Z"
});

var SvgDatabase = function SvgDatabase(props) {
  return _ref;
};

export default SvgDatabase;